import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//Common
import { Snackbar } from "../../common/VFX-UI";

//App
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { apiErrorMessage } from "../../../utility/lib/error";
import { SnackbarState } from "../../../types";
import { RoleFormContainerProps } from "../../../types/role";
import { RoleContext } from "./RoleContainer";
import { RoleDto } from "../../../app/model/api/types/dto/roleDto";
import roleApi from "../../../app/model/api/roleApi";
import { RoleViewModel } from "../../../viewModels/roleViewModel";
import RoleForm from "./RoleForm";

const RoleFormContainer: React.FC<RoleFormContainerProps> = (props) => {
  const { onClose, onShowSuccess } = props;
  const roleContext = useContext(RoleContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = roleContext?.id ? "Role updated" : "New Role added";

  const onShowErrorSnackbar = (errorMessage: string) =>
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });

  const onCloseSnackbar = () =>
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });

  const { status, mutate } = useMutation<void, Error, RoleDto>({
    mutationFn: async (payload: RoleDto) => {
      const response = await roleApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleSubmit = async (values: RoleViewModel) => {
    const role: RoleDto = values.toDto();
    mutate(role);
  };

  const initialValues = roleContext?.id
    ? new RoleViewModel(
        roleContext?.data?.id ?? null,
        roleContext?.data?.name ?? null
      )
    : new RoleViewModel(EMPTY_GUID, "");

  return (
    <>
      <RoleForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};

export default RoleFormContainer;
